import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, Label, Input, Button, Spinner } from 'reactstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FaTimes } from 'react-icons/fa';
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { RiAddCircleLine, RiDeleteBinLine } from 'react-icons/ri';

const AddArticle = () => {
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [articleName, setArticleName] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  // const [videoLink, setVideoLink] = useState('');
  const [videoLinks, setVideoLinks] = useState(['']);

  const [articleImages, setArticleImages] = useState([]);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  
  const handleDescriptionChange = (event, editor) => {
    const data = editor.getData();
    setDescription(data);
  };


  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    let validImages = [];
    let imageError = '';

    files.forEach(file => {
      if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
        imageError = 'Only jpg, jpeg, and png files are allowed';
      } else if (file.size / 1000000 > 5) {
        imageError = 'File size should be less than 5MB';
      } else {
        validImages.push(file);
      }
    });

    setArticleImages([...articleImages, ...validImages]);

    setErrors(prevErrors => ({ ...prevErrors, articleImages: imageError }));
  };

  const removeImage = (index) => {
    const updatedImages = articleImages.filter((_, i) => i !== index);
    setArticleImages(updatedImages);
    if (updatedImages.length === 0) {
      setFileInputKey(Date.now());
    }
  };

  const validate = () => {
    const errors = {};
    if (!articleName) {
      errors.articleName = "Article name is required";
    }
    if (!title) {
      errors.title = "Title is required";
    }
    if (!description) {
      errors.description = "Description is required";
    }
    if (articleImages.length === 0) {
      errors.articleImages = "At least one image is required";
    }
    return errors;
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
   
      const formData = new FormData();
      formData.append('articleName', articleName);
      formData.append('title', title);
      formData.append('description', description);
      for (const link of videoLinks) {
        formData.append('videoLink', link);
      }
      articleImages.forEach(image => {
        formData.append('articleImages', image);
      });

      try {
        setLoader(true);
        let saveData = await ApiClient._postFormData(
           `admin/add-article`,
           formData,
           true,
           dispatch
         );
        if (saveData.status === true) {
          toast.success(saveData.message, { autoClose: 3000 });
          setLoader(false);
          setArticleName('')
          setDescription('')
          setTitle('')
          setVideoLinks([''])
          setArticleImages([])
          navigate('/admin/article/list')
        } else {
          toast.success(saveData.message, { autoClose: 3000 });
          setLoader(false);
        }
      } catch (error) {
        toast.error(error.message, { autoClose: 3000 });
        setLoader(false);
      }
    }
  };

  const handleRemoveVideoLink = (index) => {
    const newVideoLinks = videoLinks.filter((_, i) => i !== index);
    setVideoLinks(newVideoLinks);
  };

  const handleAddVideoLink = () => {
    setVideoLinks([...videoLinks, '']);
  };

  const handleVideoLinkChange = (index, value) => {
    const newVideoLinks = videoLinks.map((link, i) => (i === index ? value : link));
    setVideoLinks(newVideoLinks);
  };


  console.log(articleImages,"article from add screen")
  return (
    <div className="content">
      <Container>
        <Card>
          <CardBody>
            <form onSubmit={handleSubmit}>
              <Row className="mt-3">
                <Col md="6">
                  <Label for="articleName" className="card-heading">Article Name:</Label>
                  <Input
                    type="text"
                    id="articleName"
                    name="articleName"
                    value={articleName}
                    onChange={(e) => setArticleName(e.target.value)}
                  />
                  {errors.articleName && (
                    <div className="error-message ">{errors.articleName}</div>
                  )}
                </Col>
                <Col md="6">
                  <Label for="title" className="card-heading">Title:</Label>
                  <Input
                    type="text"
                    id="title"
                    name="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                  {errors.title && (
                    <div className="error-message ">{errors.title}</div>
                  )}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md="12">
                  <Label for="description" className="card-heading">Description:</Label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={description}
                    onChange={handleDescriptionChange}
                    config={{
                      removePlugins: ['ImageUpload', 'MediaEmbed', 'EasyImage', 'ImageToolbar', 'ImageCaption', 'ImageStyle', 'ImageResize', 'ImageInsert'],
                      toolbar: [
                        'heading', '|',
                        'bold', 'italic', 'link', '|',
                        'bulletedList', 'numberedList', '|',
                        'blockQuote', 'insertTable', '|',
                        'undo', 'redo'
                      ]
                    }}
                  />
                  {errors.description && (
                    <div className="error-message ">{errors.description}</div>
                  )}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md="6">
                  <Label for="videoLink" className="card-heading">Video Link:</Label>
              {videoLinks.map((link, index) => (
              <Row key={index} className="mb-2 align-items-center">
                <Col md={10}>
                  <Input
                    type="text"
                    value={link}
                    onChange={(e) => handleVideoLinkChange(index, e.target.value)}
                  />
                </Col>
                <Col md={2} className="text-right">
                  <Button color="link" onClick={() => handleRemoveVideoLink(index)}>
                    <RiDeleteBinLine size={24} />
                  </Button>
                </Col>
              </Row>
            ))}
               <Button color="link" onClick={handleAddVideoLink}>
              <RiAddCircleLine size={24} />
            </Button>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md="12">
                  <Label for="articleImage" className="card-heading">Article Images:</Label>
                  <Input
                    type="file"
                    key={fileInputKey} // Add the key prop to force re-render
                    id="articleImage"
                    name="articleImage"
                    onChange={handleImageChange}
                    accept=".jpg,.jpeg,.png"
                    multiple
                  />
                  {errors.articleImages && (
                    <div className="error-message ">{errors.articleImages}</div>
                  )}
                  <div className="image-previews mt-3">
                    {articleImages.map((image, index) => (
                      <div key={index} style={{ display: 'inline-block', position: 'relative', marginRight: '10px' }}>
                        <img
                          src={URL.createObjectURL(image)}
                          alt={`preview-${index}`}
                          style={{ width: '100px' }}
                        />
                        <FaTimes
                          onClick={() => removeImage(index)}
                          style={{
                            position: 'absolute',
                            top: '5px',
                            right: '5px',
                            cursor: 'pointer',
                            color: 'black'
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
             
              <Button type="submit" color="primary" className="ml-10 mt-4 common-button">
                Submit
             {loader && <Spinner size="sm"className='ml-2' />}
              </Button>
            </form>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AddArticle;
